import Buffer from '@turf/buffer'
import Simplify from '@turf/simplify'
import { mapStore } from '../../state/mapStore'
import { IMapBoxDirections } from '../../types'

export const calculateSimplifiedPolygon = (json: IMapBoxDirections) => {
    const distanceFromRouteSelection = mapStore.getState().distanceFromRouteSelection
    const setStepCoordinates = mapStore.getState().setStepCoordinates
    const pointsArr: number[][] = []
    json?.routes?.[0]?.geometry?.coordinates?.map((coord) => pointsArr.push(coord))
    const feature = {
        features: [
            {
                geometry: { coordinates: pointsArr, type: 'LineString' },
                properties: {},
                type: 'Feature',
            },
        ],
        type: 'FeatureCollection',
    } as unknown as mapboxgl.MapboxGeoJSONFeature
    const polygon = Buffer(feature, distanceFromRouteSelection?.value * 0.05, {
        units: 'miles',
    })
    const simplifiedPolygon = Simplify(polygon, {
        tolerance: 0.01,
        highQuality: true,
        mutate: true,
    })
    setStepCoordinates(
        (simplifiedPolygon as unknown as GeoJSON.FeatureCollection<GeoJSON.GeometryObject | any>)
            ?.features?.[0]?.geometry?.coordinates?.[0]
    )
}
